import axiosClient from "@/config/api/axios";
import { CHAT_RUNS } from "@/config/api/endpoints";
import { isApiConfigured } from "@/config/api/env";
import { publicTimelineResponseSchema } from "@/schemas/contracts/publicTimeline";

export async function fetchPublicTimeline(runId, { cursor, signal } = {}) {
  if (!isApiConfigured() || !runId)
    return {
      phases: [],
      steps: [],
      next_cursor: null,
      has_more: false,
      pending_count: 0,
      started_at: null,
      completed_at: null,
    };
  const { data } = await axiosClient.get(`${CHAT_RUNS}/${runId}/timeline`, {
    signal,
    params: cursor ? { cursor } : undefined,
  });
  return publicTimelineResponseSchema.parse(data);
}
